import React, { useEffect, useRef, useState } from 'react'
import "../../styles/profileStyles/myProfileSettings.css";
import BeatLoader from 'react-spinners/BeatLoader';

export default function MyProfileSettings({ addToast }) {
    const [isUsernameModalOpen, setIsUsernameModalOpen] = useState(false);
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

    // ADATOK
    const [newUsername, setNewUsername] = useState("");

    const [oldPassword, setOldPassword] = useState("");
    const [newPasswordFirst, setNewPasswordFirst] = useState("");
    const [newPasswordSecond, setNewPasswordSecond] = useState("");

    const [passwordVerify, setPasswordVerify] = useState("");

    const [emailEnabled, setEmailEnabled] = useState(true);


    const [accountDatas, setAccountDatas] = useState(null);

    const isFirstRender = useRef(true);
    const fileInputRef = useRef();

    // FELHASZNÁLÓNÉV MÓDOSITÁS
    const handleUsernameModify = () => {
        if (!newUsername.trim()) {
            addToast("Adj meg egy felhasználónevet!", "warning");
            return;
        }
        fetch("https://focifanatik.hu/api/profile_API/profileSettings/profileSettingsUpdateUsername.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                updatedUsername: newUsername
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    addToast(data.error, "warning");
                } else {
                    setAccountDatas(prev => ({
                        ...prev,
                        username: newUsername
                    }));
                    addToast("Sikeres módosítás!", "success");
                    setIsUsernameModalOpen(false);
                    setNewUsername("");
                }
            })
            .catch(err => {
                console.log("Hiba:", err);
            });
    }

    // JELSZÓ MÓDOSITÁS
    const handlePasswordModify = () => {
        if (newPasswordFirst != newPasswordSecond) {
            addToast("Nem egyezik a két jelszó!", "warning");
            return;
        }
        fetch("https://focifanatik.hu/api/profile_API/profileSettings/profileSettingsUpdatePassword.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                oldPassword: oldPassword,
                newPasswordFirst: newPasswordFirst,
                newPasswordSecond: newPasswordSecond
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    addToast(data.error, "warning");
                } else {
                    addToast("Sikeres jelszó módosítás!", "success");
                    setIsPasswordModalOpen(false);
                    setOldPassword("");
                    setNewPasswordFirst("");
                    setNewPasswordSecond("");
                }
            })
            .catch(err => {
                console.log("Hiba:", err);
            });
    }

    // PROFIL TÖRLÉSE
    const handleDeleteProfile = () => {
        fetch("https://focifanatik.hu/api/profile_API/profileSettings/profileSettingsDeleteProfile.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                password: passwordVerify
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    addToast(data.error, "warning");
                } else {
                    addToast("Sikeres profil törlés!", "success");
                    setIsDeleteModalOpen(false);
                    setPasswordVerify("");
                    window.location.href = "/";
                }
            })
            .catch(err => {
                console.log("Hiba:", err);
            });
    }

    // EMAIL ÉRTESITÉS VÁLTOZTATÁS
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        fetch("https://focifanatik.hu/api/profile_API/profileSettings/profileSettingsUpdateEmailNotify.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                emailNotifyUpdate: emailEnabled
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    addToast(data.error, "warning");
                } else {
                    addToast("Sikeres módositás!", "success");
                }
            })
            .catch(err => {
                console.log("Hiba:", err);
            });
    }, [emailEnabled]);

    // ALAP ADATOK LEKÉRÉSE
    useEffect(() => {
        fetch("https://focifanatik.hu/api/profile_API/profileSettings/profileSettingsDatas.php")
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setAccountDatas(data);
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);

    //MEGNÉZZÜK KI A BEJELENTKEZETT FELHASZNÁLÓ
    useEffect(() => {
        fetch("https://focifanatik.hu/api/session_check.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (!data.loggedIn) {
                    // window.location.href = "/regisztracio";
                }
            });
    }, []);


    // PROFILKÉP FELTÖLTÉSE
    const handleProfileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("profilePic", file);

        try {
            const res = await fetch("https://focifanatik.hu/api/profile_API/profileSettings/profileSettingsUpdateProfilePic.php", {
                method: "POST",
                body: formData,
                credentials: "include"
            });

            const data = await res.json();

            if (data.success) {
                addToast("Sikeres feltöltés!", "success");

                setAccountDatas(prev => ({
                    ...prev,
                    profile_picture: data.path
                }));

            } else {
                addToast(data.error || "Hiba", "warning");
            }

        } catch (err) {
            addToast("Szerver hiba!", "warning");
        }

    };


    if (!accountDatas) {
        return (
            <>
                <div className='loading-bg-profileBar'><BeatLoader color="white" size={55} /></div>
                <div className='loading-bg-content'></div>
            </>
        );
    }

    return (
        <>

            <div className='myProfileSettingsPage-topProfileBar'>

                <h1><i class="bi bi-bookmarks"></i></h1>
                <h1>asd</h1>

            </div>

            {/* TARTALOM */}
            <div className='myProfileSettings-content'>
                <div className='myProfileSettingsGrid'>

                    <div className='myProfileSettingsUsernameBox'>
                        <span>Felhasználónév</span>
                        <span>Tippmester123asdasd</span>
                    </div>

                    <div
                        className='myProfileSettingsUsernameModifyBox'
                        onClick={() => setIsUsernameModalOpen(true)}
                    >
                        <span>Felhasználónév módositása</span>
                        <i class="bi bi-arrow-right"></i>
                    </div>

                    <div
                        className='myProfileSettingsPasswordModifyBox'
                        onClick={() => setIsPasswordModalOpen(true)}
                    >
                        <span>Jelszó módositása</span>
                        <i class="bi bi-arrow-right"></i>
                    </div>

                    <div className='myProfileSettingsProfilePictureBox'>
                        <span>Profilkép módositása</span>
                        <img src={`https://focifanatik.hu/${accountDatas.profile_picture}`} />
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            accept="image/*"
                            onChange={handleProfileUpload}
                        />
                        <button onClick={() => fileInputRef.current.click()}>
                            Feltöltés
                        </button>
                    </div>

                    <div className='myProfileSettingsEmailNotifyBox'>
                        <span>Email értesitések</span>
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={emailEnabled}
                                onChange={(e) => {
                                    if (e.target.checked === false) {
                                        setIsEmailModalOpen(true);
                                    }
                                    else {
                                        setEmailEnabled(true);
                                    }
                                }}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                    <div className='myProfileSettingsAccountDeleteBox'>
                        <span>Fiók törlése</span>
                        <button onClick={() => setIsDeleteModalOpen(true)}>Fiók törlése</button>
                    </div>

                </div>
            </div>

            {/* ----------------------------------------------------- MODAL ABLAKOK ---------------------------------------------------- */}
            {/* USERNAME MODAL */}
            {isUsernameModalOpen && (
                <div className="modalOverlay" onClick={() => setIsUsernameModalOpen(false)}>
                    <div className="modal">
                        <h2>Felhasználónév módosítása</h2>

                        <input
                            type="text"
                            placeholder="Új felhasználónév"
                            value={newUsername}
                            onChange={(e) => setNewUsername(e.target.value)}
                        />

                        <div className="modalButtons">
                            <button onClick={() => {
                                setIsUsernameModalOpen(false)
                                setNewUsername("");
                            }}>
                                Mégse
                            </button>
                            <button onClick={handleUsernameModify}>
                                Mentés
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* PASSWORD MODAL */}
            {isPasswordModalOpen && (
                <div className="modalOverlay" onClick={() => setIsPasswordModalOpen(false)}>
                    <div className="modal">
                        <h2>Jelszó módosítása</h2>

                        <input
                            type="password"
                            placeholder="Régi jelszó"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                        />
                        <input
                            type="password"
                            placeholder="Új jelszó"
                            value={newPasswordFirst}
                            onChange={(e) => setNewPasswordFirst(e.target.value)}
                        />
                        <input
                            type="password"
                            placeholder="Új jelszó mégegyszer"
                            value={newPasswordSecond}
                            onChange={(e) => setNewPasswordSecond(e.target.value)}
                        />

                        <div className="modalButtons">
                            <button onClick={() => {
                                setIsPasswordModalOpen(false)
                                setOldPassword("");
                                setNewPasswordFirst("");
                                setNewPasswordSecond("");
                            }}>
                                Mégse
                            </button>
                            <button>
                                Mentés
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {isDeleteModalOpen && (
                <div className="modalOverlay" onClick={() => setIsDeleteModalOpen(false)}>
                    <div className="modal" onClick={(e) => e.stopPropagation()}>

                        <h2>Biztos törölni akarod a fiókod?</h2>
                        <p>Ez a művelet nem visszavonható.</p>

                        <input
                            type="password"
                            placeholder="Add meg a jelszavadat"
                            value={passwordVerify}
                            onChange={(e) => setPasswordVerify(e.target.value)}
                        />

                        <div className="modalButtons">
                            <button onClick={() => setIsDeleteModalOpen(false)}>
                                Mégse
                            </button>
                            <button style={{ background: "red" }} onClick={handleDeleteProfile}>
                                Törlés
                            </button>
                        </div>

                    </div>
                </div>
            )}
            {isEmailModalOpen && (
                <div className="modalOverlay" onClick={() => setIsEmailModalOpen(false)}>
                    <div className="modal" onClick={(e) => e.stopPropagation()}>

                        <h2>Email értesítések</h2>
                        <p>Biztosan ki szeretnéd kapcsolni az email értesítéseket?</p>

                        <div className="modalButtons">
                            <button onClick={() => setIsEmailModalOpen(false)}>
                                Mégse
                            </button>
                            <button onClick={() => {
                                setEmailEnabled(false);
                                setIsEmailModalOpen(false);
                            }}>
                                Igen
                            </button>
                        </div>

                    </div>
                </div >
            )
            }



        </>
    )
}
